(() => {
  if (window.__RavinPaperGangV2) return;
  window.__RavinPaperGangV2 = true;
  const rootSelector = '[data-rv-paper-gang]';
  const esc = value => String(value || '').trim();

  function init(root) {
    if (root.dataset.gangVersion === '2') return;
    root.dataset.gangVersion = '2';
    const trigger = root.querySelector('[data-gang-trigger]');
    const overlay = root.querySelector('[data-gang-overlay]');
    const dialog = root.querySelector('[data-gang-dialog]');
    const closeButton = root.querySelector('[data-gang-close]');
    const tabs = Array.from(root.querySelectorAll('[data-gang-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-gang-panel]'));
    const noticesContainer = root.querySelector('[data-gang-notices]');
    const empty = root.querySelector('[data-gang-empty]');
    const badge = root.querySelector('[data-gang-count]');
    const tabBadge = root.querySelector('[data-gang-tab-count]');
    const chat = root.querySelector('[data-gang-chat]');
    const vip = root.querySelector('[data-gang-vip]');
    const vipView = root.querySelector('[data-gang-vip-view]');
    const vipFrame = root.querySelector('[data-gang-vip-frame]');
    const vipStatus = root.querySelector('[data-gang-vip-status]');
    const vipFallback = root.querySelector('[data-gang-vip-fallback]');
    const vipConfig = document.getElementById(root.id.replace('RavinPaperGang-','RavinGangVipConfig-'));
    const VIP_PORTAL_ORIGIN = 'https://gemini-shopify-sidekick-134454556428.europe-west2.run.app';
    const vipBack = root.querySelector('[data-gang-vip-back]');
    const vipLoading = root.querySelector('[data-gang-vip-loading]');
    const vipExternal = root.querySelector('[data-gang-vip-external]');
    const shakeButton = root.querySelector('[data-gang-shake]');
    const rivalsPanel = root.querySelector('[data-gang-panel="rivals"]');
    const men = root.querySelector('[data-gang-men]');
    const women = root.querySelector('[data-gang-women]');
    const ar = root.dataset.gangLang === 'ar';
    let opened = false;
    let active = 'notes';
    let vipMode = false;
    let vipReady = false;
    let vipFailureTimer = 0;
    let shakeTimer = 0;
    let lastFocus = null;
    let savedOverflow = null;
    let notesObserver = null;
    let observedSource = null;
    let refreshPending = false;
    let syncTimer = null;

    if (!trigger || !overlay || !dialog || !vipView || !vipFrame) return;
    document.body.appendChild(overlay);
    overlay.inert = true;
    overlay.hidden = true;
    const original = {
      notes: () => document.querySelector('[data-ravin-notifications]'),
      rivals: () => document.querySelector('[data-rv-rivals]'),
      pulse: () => document.querySelector('[data-ravin-pulse]')
    };
    function remaining() {
      return Array.from(original.notes()?.querySelectorAll('[data-rn-notice]:not([hidden])') || []);
    }
    function setBadge(element, count) {
      if (!element) return;
      element.hidden = count === 0;
      element.textContent = count > 99 ? '99+' : String(count);
    }
    function syncActions() {
      const rivals = original.rivals();
      const pulse = original.pulse();
      const menSource = rivals?.querySelector('[data-rv-choice="men"]');
      const womenSource = rivals?.querySelector('[data-rv-choice="women"]');
      const vipSource = pulse?.querySelector('[data-rp-vip]');
      if (menSource?.getAttribute('href')) men.href = menSource.href;
      if (womenSource?.getAttribute('href')) women.href = womenSource.href;
      if (vipSource?.getAttribute('href') && vipExternal) {
        vipExternal.href = vipSource.href;
        if (vipFallback) vipFallback.href = vipSource.href;
      }
      const nativeChat = document.querySelector('body > button.ravin-launcher-btn');
      const pulseChat = pulse?.querySelector('[data-rp-chat]');
      chat.disabled = !(nativeChat || (pulseChat && !pulseChat.disabled));
      chat.title = chat.disabled ? (ar ? 'خدمة العملاء غير متاحة حالياً' : 'Chat is temporarily unavailable') : '';
    }
    function renderNotices() {
      const items = remaining();
      setBadge(badge, items.length);
      setBadge(tabBadge, items.length);
      trigger.setAttribute('aria-label', (ar ? 'افتح شخصيات ريفين' : 'Open RAVIN Paper Gang') + (items.length ? (ar ? '، الإشعارات ' : ', notifications ') + items.length : ''));
      empty.hidden = items.length > 0;
      noticesContainer.replaceChildren();
      items.forEach((source, i) => {
        const title = esc(source.querySelector('.ravin-notifications__eyebrow [data-rv-style="eyebrow"]')?.textContent || source.querySelector('.ravin-notifications__eyebrow')?.textContent);
        const bodyText = esc(source.querySelector('.ravin-notifications__static-message [data-rv-style="message"]')?.textContent || source.querySelector('.visually-hidden [data-rv-style="message"]')?.textContent || source.querySelector('.ravin-notifications__ticker-copy [data-rv-style="message"]')?.textContent || source.querySelector('.ravin-notifications__message')?.textContent);
        const link = source.querySelector('a.ravin-notifications__surface[href]');
        const card = document.createElement('article');
        card.className = 'rv-paper-gang__notice';
        const content = document.createElement(link ? 'a' : 'div');
        content.className = 'rv-paper-gang__notice-action';
        if (link) { content.href = link.href; if (link.target) content.target = link.target; }
        const titleEl = document.createElement('span');
        titleEl.className = 'rv-paper-gang__notice-label';
        titleEl.textContent = title || 'RAVIN';
        const messageEl = document.createElement('span');
        messageEl.className = 'rv-paper-gang__notice-message';
        messageEl.textContent = bodyText;
        content.append(titleEl, messageEl);
        if (link) {
          const arrow = document.createElement('span');
          arrow.className = 'rv-paper-gang__notice-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          const ico = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          ico.setAttribute('viewBox','0 0 24 24');
          const path = document.createElementNS('http://www.w3.org/2000/svg','path');
          path.setAttribute('d','M5 18 18 5M7 5h11v11');
          path.setAttribute('fill','none');
          path.setAttribute('stroke','currentColor');
          path.setAttribute('stroke-width','2');
          path.setAttribute('stroke-linecap','round');
          path.setAttribute('stroke-linejoin','round');
          ico.appendChild(path);
          arrow.appendChild(ico);
          content.append(arrow);
        }
        const dismiss = document.createElement('button');
        dismiss.type = 'button';
        dismiss.className = 'rv-paper-gang__notice-dismiss';
        dismiss.setAttribute('aria-label', ar ? 'إخفاء الإشعار' : 'Dismiss notification');
        dismiss.textContent = '×';
        dismiss.addEventListener('click', () => {
          const sourceDismiss = source.querySelector('[data-rn-dismiss]');
          if (sourceDismiss) sourceDismiss.click();
          else source.hidden = true;
          renderNotices();
        });
        card.append(content, dismiss);
        noticesContainer.append(card);
      });
    }
    function watchNotices() {
      const source = original.notes();
      if (source === observedSource) return;
      if (notesObserver) notesObserver.disconnect();
      observedSource = source;
      if (!source) return;
      notesObserver = new MutationObserver(records => {
        if (!records.some(r => r.type === 'childList' || (r.type === 'attributes' && r.attributeName === 'hidden'))) return;
        if (refreshPending) return;
        refreshPending = true;
        requestAnimationFrame(() => { refreshPending = false; renderNotices(); });
      });
      notesObserver.observe(source, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
    }
    function shakeRivals() {
      if (!rivalsPanel || rivalsPanel.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearTimeout(shakeTimer);
      rivalsPanel.classList.remove('is-shaking');
      void rivalsPanel.offsetWidth;
      rivalsPanel.classList.add('is-shaking');
      shakeTimer = setTimeout(() => rivalsPanel.classList.remove('is-shaking'), 800);
    }
    function sendVipConfig() {
      if (!vipFrame.contentWindow || !vipConfig) return;
      try {
        const payload = JSON.parse(vipConfig.textContent || 'null');
        if (!payload || payload.schemaVersion !== '2026.1' || payload.source !== 'shopify_theme_settings') return;
        vipFrame.contentWindow.postMessage({
          type:'RAVIN_VIP_THEME_CONFIG_SYNC',
          schemaVersion:'2026.1',
          source:'shopify_theme_settings',
          payload
        }, VIP_PORTAL_ORIGIN);
      } catch(error) {}
    }
    function vipUnavailable() {
      if (!vipMode || vipReady) return;
      if (vipStatus) vipStatus.classList.add('is-unavailable');
      if (vipLoading) vipLoading.textContent = ar
        ? 'صفحة الـ VIP مش بتظهر هنا دلوقتي. افتح صفحة النادي الكاملة.'
        : 'The VIP portal could not load here. Open the full VIP page to continue.';
    }
    function closeVip() {
      if (!vipMode) return;
      vipMode = false;
      clearTimeout(vipFailureTimer);
      vipView.hidden = true;
      overlay.classList.remove('is-vip');
    }
    function openVip() {
      switchTo('pulse', false);
      vipMode = true;
      panels.forEach(panel => { panel.hidden = true; });
      vipView.hidden = false;
      overlay.classList.add('is-vip');
      if (vipStatus) {
        vipStatus.hidden = vipReady;
        vipStatus.classList.remove('is-unavailable');
      }
      if (vipLoading) vipLoading.textContent = ar
        ? 'بنجهز بطاقة الـ VIP بتاعتك...'
        : 'Getting your VIP pass ready...';
      clearTimeout(vipFailureTimer);
      const raw = vipFrame.dataset.gangVipSrc || '';
      let url;
      try {
        url = new URL(raw, window.location.href);
        if (url.origin !== VIP_PORTAL_ORIGIN || url.pathname !== '/vip-portal') throw new Error('Unexpected portal URL');
      } catch(error) {
        vipUnavailable();
        return;
      }
      if (vipFrame.dataset.url !== url.href) {
        vipReady = false;
        if (vipStatus) vipStatus.hidden = false;
        vipFrame.dataset.url = url.href;
        vipFrame.src = url.href;
      } else if (vipReady && vipStatus) {
        vipStatus.hidden = true;
        sendVipConfig();
      }
      if (!vipReady) vipFailureTimer = setTimeout(vipUnavailable, 11000);
    }
    function switchTo(id, moveFocus) {
      if (!['notes','rivals','pulse'].includes(id)) return;
      closeVip();
      active = id;
      tabs.forEach(tab => {
        const selected = tab.dataset.gangTab === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) tab.focus({ preventScroll: true });
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.gangPanel !== id; });
      if (id === 'notes') renderNotices();
      if (id === 'pulse') syncActions();
      if (id === 'rivals') requestAnimationFrame(shakeRivals);
    }
    function open() {
      if (opened) return;
      opened = true;
      watchNotices();
      syncActions();
      renderNotices();
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      overlay.hidden = false;
      overlay.inert = false;
      trigger.setAttribute('aria-expanded', 'true');
      trigger.tabIndex = -1;
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      const defaultTab = root.dataset.gangAutonotes === 'true' && remaining().length ? 'notes' : 'rivals';
      switchTo(defaultTab, false);
      closeButton.focus({ preventScroll: true });
    }
    function close(restoreFocus = true) {
      if (!opened) return;
      opened = false;
      root.classList.remove('is-open');
      closeVip();
      clearTimeout(shakeTimer);
      rivalsPanel?.classList.remove('is-shaking');
      overlay.hidden = true;
      overlay.inert = true;
      trigger.setAttribute('aria-expanded','false');
      trigger.removeAttribute('tabindex');
      document.body.style.overflow = savedOverflow === null ? '' : savedOverflow;
      savedOverflow = null;
      if (restoreFocus && lastFocus?.focus) lastFocus.focus({ preventScroll:true });
    }
    trigger.addEventListener('click', open);
    shakeButton?.addEventListener('click', event => { event.preventDefault(); shakeRivals(); });
    vip?.addEventListener('click', event => { event.preventDefault(); openVip(); });
    vipBack?.addEventListener('click', () => { switchTo('pulse', false); vip.focus({preventScroll:true}); });
    vipFrame.addEventListener('load', () => {
      sendVipConfig();
    });
    window.addEventListener('message', event => {
      if (event.origin !== VIP_PORTAL_ORIGIN || event.source !== vipFrame.contentWindow) return;
      const message = event.data;
      if (!message || typeof message !== 'object') return;
      if (message.type === 'RAVIN_VIP_PORTAL_READY') {
        vipReady = true;
        clearTimeout(vipFailureTimer);
        if (vipStatus) vipStatus.hidden = true;
        sendVipConfig();
      }
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target?.contains(root)) {close(false);overlay.remove();}
    });

    closeButton.addEventListener('click', () => close());

    // Outside means outside the *visible* circle and content card, not merely
    // outside their large rectangular modal wrapper. Using pointerdown to hide
    // the overlay can cause iOS Safari's subsequent synthetic click to reopen
    // the launcher beneath it, so normal clicks close on click, not pointerdown.
    const orbit = dialog.querySelector('.rv-paper-gang__orbit');
    const card = dialog.querySelector('.rv-paper-gang__card');
    function inRectangle(el, x, y) {
      if (!el || el.hidden) return false;
      const b = el.getBoundingClientRect();
      return b.width > 0 && b.height > 0 &&
        x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
    }
    function inVisibleGang(target, x, y) {
      // Preserve all real controls, including buttons that protrude slightly
      // beyond the circle, and controls in the VIP view.
      const interactive = target && target.closest?.('button,a,input,textarea,select,iframe,[role="tab"]');
      if (interactive && dialog.contains(interactive)) return true;
      if (inRectangle(card, x, y)) return true;
      if (orbit && orbit.getClientRects().length) {
        const b = orbit.getBoundingClientRect();
        const cx = b.left + b.width / 2;
        const cy = b.top + b.height / 2;
        const radius = Math.min(b.width,b.height) / 2 + 2;
        if ((x-cx)*(x-cx) + (y-cy)*(y-cy) <= radius*radius) return true;
      }
      return false;
    }
    function closeIfOutside(target, x, y, event) {
      if (!opened || inVisibleGang(target, x, y)) return false;
      // A modal backdrop tap should close the gang, not activate an unrelated
      // product/link behind the backdrop on the same tap.
      if (event?.cancelable) event.preventDefault();
      event?.stopPropagation();
      close(false);
      return true;
    }
    // Desktop mouse, keyboard-synthesized clicks, and standard mobile clicks.
    // Window capture runs before any nested theme handlers stop propagation.
    window.addEventListener('click', event => {
      closeIfOutside(event.target, event.clientX, event.clientY, event);
    }, true);

    // iOS Safari: do not rely solely on clicks from noninteractive backdrop
    // elements. End the touch only if it was a tap, and prevent a ghost click.
    let gangTouchStart = null;
    overlay.addEventListener('touchstart', event => {
      const t = event.touches[0];
      gangTouchStart = t && event.touches.length === 1 ?
        { x:t.clientX, y:t.clientY } : null;
    }, {passive:true,capture:true});
    overlay.addEventListener('touchend', event => {
      const t = event.changedTouches[0];
      const s = gangTouchStart;
      gangTouchStart = null;
      if (!opened || !t || !s) return;
      if (Math.hypot(t.clientX-s.x,t.clientY-s.y) > 12) return;
      closeIfOutside(event.target, t.clientX, t.clientY, event);
    }, {passive:false,capture:true});
    overlay.addEventListener('touchcancel', () => { gangTouchStart=null; }, {passive:true});

    tabs.forEach(tab => {
      tab.addEventListener('click', () => switchTo(tab.dataset.gangTab, false));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const current = tabs.indexOf(tab);
        const idx = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        switchTo(tabs[idx].dataset.gangTab, true);
      });
    });
    chat.addEventListener('click', () => {
      syncActions();
      if (chat.disabled) return;
      const pulseButton = original.pulse()?.querySelector('[data-rp-chat]');
      const native = document.querySelector('body > button.ravin-launcher-btn');
      close(false);
      if (pulseButton && !pulseButton.disabled) pulseButton.click();
      else native?.click();
    });
    document.addEventListener('keydown', event => {
      if (!opened) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],iframe,[tabindex="0"]')).filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0);
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('shopify:section:load', () => { watchNotices(); syncActions(); renderNotices(); });
    window.addEventListener('pageshow', () => { close(false); syncActions(); watchNotices(); renderNotices(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) close(false); });
    watchNotices();
    syncActions();
    renderNotices();
    let attempts = 0;
    syncTimer = setInterval(() => {
      if (!root.isConnected || ++attempts > 35) { clearInterval(syncTimer); return; }
      watchNotices();
      syncActions();
    }, 1300);
  }
  const start = () => document.querySelectorAll(rootSelector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();